module.exports = __webpack_public_path__ + "static/brian-30a495c825008446507c681ce0cb56a3.jpg";